import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoadingSpinner } from '../components/LoadingSpinner'

/**
 * Auth Callback Page
 * 
 * Better Auth handles callbacks internally, so this page just redirects
 * to the home page. It's kept for backward compatibility with existing routes.
 */
export const AuthCallback = () => {
  const navigate = useNavigate()

  useEffect(() => {
    // Better Auth handles callbacks internally
    // Just redirect to home
    navigate('/', { replace: true })
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="lg" className="mx-auto" />
        <p className="mt-4 text-gray-600">Completing sign in...</p>
      </div>
    </div>
  )
}
